// For clarity, imports are ordered according to flow (order in which the pages are viewed)

import Home from "./pages/Home.vue";
import Credits from "./pages/Credits.vue";
import Settings from "./pages/Settings.vue";
import Game1 from "./pages/Game1.vue";
import Game2 from "./pages/Game2.vue";
import Extras from "./pages/Extras.vue";
import ParentsArea from "./pages/ParentsArea.vue";
import Profiles from "./pages/Profiles.vue";
import Music from "./pages/Music.vue";
import ManageAccount from "./pages/ManageAccount.vue";
//@todo: temporary!! remove
import Game1_suzie from "./pages/Game1_suzie.vue";

const routes =
    [
        {
            path: "/",
            name: "home",
            component: Home
        },

        {
            path: "/:lang(fr|en)",
            name: "home-with-lang",
            component: Home
        },

        {
            path: "/:lang(fr|en)/credits",
            name: "credits",
            component: Credits
        },

        {
            path: "/:lang(fr|en)/settings",
            name: "settings",
            component: Settings
        },

        {
            path: "/:lang(fr|en)/game-1",
            name: "game-1",
            component: Game1
        },

        {
            path: "/:lang(fr|en)/game-1-suzie",
            name: "game-1-suzie",
            component: Game1_suzie
        },

        {
            path: "/:lang(fr|en)/game-2",
            name: "game-2",
            component: Game2
        },

        {
            path: "/:lang(fr|en)/extras",
            name: "extras",
            component: Extras
        },

        {
            path: "/:lang(fr|en)/parents-area",
            name: "parentsArea",
            component: ParentsArea
        },

        {
            path: "/:lang(fr|en)/profiles",
            name: "profiles",
            component: Profiles
        },

        {
            path: "/:lang(fr|en)/music",
            name: "music",
            component: Music
        },


        {
            path: "/:lang(fr|en)/manage-account",
            name: "manageAccount",
            component: ManageAccount
        },
    ]


export default routes;
